// Whether the promo and redeem code feature is on. One call per session, cached for the session.
//
// Loading, an error and `enabled:false` all mean off: the feature renders nothing, so the page never shifts.
import { useQuery } from '@tanstack/react-query'
import { apiV2 } from '@/lib/api-v2-client'

export const PROMO_STATUS_KEY = ['promo-status'] as const

export function usePromoStatus(): { enabled: boolean } {
  const { data } = useQuery({
    queryKey: PROMO_STATUS_KEY,
    queryFn: () => apiV2.promoStatus(),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
  return { enabled: data?.enabled === true }
}
